import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import { AntiMnyLndCommReportTable } from "./AntiMnyLndCommReportTable";
import { usePageStyles } from "../../pageStyles";
import { PageComponent } from "../../../core/navigation/types";
import { PageTitle } from "../../components/common/PageTitle";
import { AntiMnyLndCommReportFilter } from "./AntiMnyLndCommReportFilter";
import { DownloadButton, DownloadExcelButton } from "./DownloadButton";

const AntiMnyLndCommReport: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={<PageTitle title="amtimnylndcommReportTitle" />}
              action={<AntiMnyLndCommReportActions />}
            />
            <Divider />
            <CardContent>
              <AntiMnyLndCommReportTable userAccessRights={userAccessRights} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const AntiMnyLndCommReportActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <AntiMnyLndCommReportFilter />
    </Grid>
    <Grid item>
      <DownloadButton />
    </Grid>
    <Grid item>
      <DownloadExcelButton />
    </Grid>
  </Grid>
);

export default AntiMnyLndCommReport;
